import { IRequestsData } from './IRequestsData';

export class RequestsData
    implements IRequestsData {

    public countWithoutDelay: number = 0;
    public countPostponed: number = 0;
    public countWithDelay: number = 0;

    public getTotalRequestCount(): number {
        const result = this.countWithoutDelay
            + this.countWithDelay
            + this.countPostponed;
        return result;
    }

}
